import { FC } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatIconReorder } from '@blocks-react/components/Icons/Reorder';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { RefreshTooltipButtonProps } from '../types';

export const RefreshTooltipButton: FC<RefreshTooltipButtonProps> = ({
  handleEventClose,
  refreshNotification,
  title
}) => {
  return (
    <CatTooltip onBlTooltipClose={handleEventClose}>
      <>
        <CatButton
          slot="trigger"
          variant="ghost"
          hideText
          onClick={refreshNotification}
          data-testid="notification-refresh-button"
        >
          <CatIconReorder slot="after" aria-label={title} />
        </CatButton>
        <CatTextPassage size="xs">{title}</CatTextPassage>
      </>
    </CatTooltip>
  );
};
